const MIME_CANDIDATES = [
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/ogg;codecs=opus",
  "audio/ogg",
  "audio/mp4",
];

export const isMediaRecorderSupported = () =>
  typeof window !== "undefined" &&
  typeof MediaRecorder !== "undefined" &&
  typeof navigator?.mediaDevices?.getUserMedia === "function";

export const pickRecorderMimeType = () => {
  if (typeof MediaRecorder === "undefined") return "";
  if (typeof MediaRecorder.isTypeSupported !== "function") return "";
  return MIME_CANDIDATES.find((type) => MediaRecorder.isTypeSupported(type)) || "";
};

export const describeGetUserMediaError = (error) => {
  const name = error?.name || "";
  if (name === "NotAllowedError" || name === "PermissionDeniedError") {
    return {
      type: "permission",
      message:
        "Microphone permission was denied. Enable it in your browser settings to use voice input.",
    };
  }
  if (name === "NotFoundError" || name === "DevicesNotFoundError") {
    return {
      type: "audio-capture",
      message: "No microphone was found. Check that a mic is connected.",
    };
  }
  if (name === "NotReadableError" || name === "TrackStartError") {
    return {
      type: "audio-capture",
      message: "The microphone is already in use or could not be started.",
    };
  }
  return {
    type: "recording-failure",
    message: "Could not start the microphone. Please try again.",
  };
};

export const stopMediaStream = (stream) => {
  stream?.getTracks?.().forEach((track) => {
    try {
      track.stop();
    } catch {
      // Track may already be stopped.
    }
  });
};
